import { render, staticRenderFns } from "./car-info-view.vue?vue&type=template&id=f48ba2a8&scoped=true&"
import script from "./car-info-view.vue?vue&type=script&lang=ts&"
export * from "./car-info-view.vue?vue&type=script&lang=ts&"
import style0 from "./car-info-view.vue?vue&type=style&index=0&id=f48ba2a8&lang=scss&scoped=true&"
import style1 from "./car-info-view.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48ba2a8",
  null
  
)

export default component.exports